import React from "react";

interface IArrowProps {
	className?: string;
}

export const ArrowLeft = ({ className }: IArrowProps) => {
	return (
		<svg className={className} width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.6662 7.71425H4.54153L10.2768 2.20202C10.5279 1.96011 10.669 1.63202 10.669 1.28991C10.669 0.947806 10.5279 0.619712 10.2768 0.377807C10.0256 0.135901 9.68497 0 9.32979 0C8.9746 0 8.63396 0.135901 8.3828 0.377807L0.380144 8.0868C0.258717 8.20897 0.163532 8.35304 0.100051 8.51073C-0.0333504 8.8235 -0.0333504 9.17431 0.100051 9.48707C0.163532 9.64477 0.258717 9.78883 0.380144 9.91101L8.3828 17.62C8.5068 17.7404 8.65431 17.836 8.81685 17.9012C8.97938 17.9664 9.15371 18 9.32979 18C9.50586 18 9.68019 17.9664 9.84273 17.9012C10.0053 17.836 10.1528 17.7404 10.2768 17.62C10.4018 17.5006 10.501 17.3585 10.5687 17.2019C10.6364 17.0454 10.6713 16.8775 10.6713 16.7079C10.6713 16.5383 10.6364 16.3704 10.5687 16.2138C10.501 16.0573 10.4018 15.9152 10.2768 15.7958L4.54153 10.2836H18.6662C19.02 10.2836 19.3592 10.1482 19.6093 9.90729C19.8595 9.66637 20 9.33962 20 8.9989C20 8.65819 19.8595 8.33144 19.6093 8.09052C19.3592 7.8496 19.02 7.71425 18.6662 7.71425Z"
				fill="currentColor"
			/>
		</svg>
	);
};
